'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _popupMenu = require('../popup-menu/popup-menu');

var _popupMenu2 = _interopRequireDefault(_popupMenu);

var _popupMenuItem = require('../popup-menu/popup-menu-item');

var _popupMenuItem2 = _interopRequireDefault(_popupMenuItem);

var _speedtestLogo = require('../logo/speedtest-logo');

var _speedtestLogo2 = _interopRequireDefault(_speedtestLogo);

var _headerLocal = require('./header.local.css');

var _headerLocal2 = _interopRequireDefault(_headerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pickerOpen: false
    }, _this.closePicker = function () {
      return _this.setState({
        pickerOpen: false
      });
    }, _this.openPicker = function () {
      return _this.setState({
        pickerOpen: true
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          containerClassName = _props.containerClassName,
          children = _props.children,
          currentEntity = _props.currentEntity,
          entities = _props.entities,
          indexRoute = _props.indexRoute,
          Link = _props.Link;
      return _react2.default.createElement('header', {
        className: (0, _classnames2.default)(className, _headerLocal2.default.header)
      }, _react2.default.createElement('nav', {
        className: (0, _classnames2.default)(containerClassName, _headerLocal2.default.container)
      }, _react2.default.createElement('div', {
        className: _headerLocal2.default.logoWrap
      }, _react2.default.createElement(Link, {
        to: indexRoute,
        href: indexRoute,
        'aria-label': 'speedtest ' + currentEntity
      }, _react2.default.createElement(_speedtestLogo2.default, {
        color: 'light',
        entity: currentEntity
      })), entities ? _react2.default.createElement(_popupMenu2.default, {
        toggleClassName: _headerLocal2.default.toggle,
        onClick: this.openPicker,
        visible: this.state.pickerOpen,
        hide: this.closePicker,
        theme: 'dark',
        icon: 'chevron',
        iconColor: 'light',
        iconSize: 'small',
        iconRotation: 90
      }, entities.map(function (e) {
        return _react2.default.createElement(_popupMenuItem2.default, {
          id: e.name,
          href: e.url,
          key: e.name,
          rel: e.name
        }, _react2.default.createElement('span', {
          className: _headerLocal2.default.appName
        }, e.name));
      })) : null), children && _react2.default.createElement('menu', {
        className: _headerLocal2.default.menu
      }, _react2.default.createElement('ul', null, children))));
    }
  }]);

  return Header;
}(_react2.default.Component);

Header.propTypes = {
  /**
   * Class to add to header element
   */
  className: _propTypes2.default.string,

  /**
   * Class to add to nav element
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Link from react-router
   */
  Link: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node, _propTypes2.default.element]).isRequired,

  /**
   * Content to be rendered in the menu
   */
  children: _propTypes2.default.node,

  /**
   * URL to navigate to when header logo is clicked
   */
  indexRoute: _propTypes2.default.string.isRequired,

  /**
   * Which app the user is currently using (displays logo)
   */
  currentEntity: _propTypes2.default.oneOf(['apps', 'intelligence', 'custom', 'servers', 'maps']).isRequired,

  /**
   * List of all entities & their dashboard URLs
   */
  entities: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.oneOf(['apps', 'intelligence', 'custom', 'servers', 'maps']),
    url: _propTypes2.default.string
  }))
};
exports.default = Header;